const rutasUsuarios = {
  path: "usuarios",
  name: "usuarios",
  redirect: {
    name: "usuarios-index",
  },
  component: () =>
    import(
      /* webpackChunkName: "Dashboard-Usuarios-Root" */ "@/modules/dashboard/pages/usuarios"
    ),
  children: [
    {
      path: "",
      name: "usuarios-index",
      component: () =>
        import(
          /* webpackChunkName: "Dashboard-Usuarios" */ "@/modules/dashboard/pages/usuarios/UsuariosPage"
        ),
    },
  ],
};

export default rutasUsuarios;
